import React from "react"
import AdForm from "./adForm";
import ApiService from "../../../Services/ApiService";
import AlertService from "../../../Services/AlertService";
import { DesignEditor } from '../../../components/design-editor';
import {useCallback} from 'react';
import _debounce from 'lodash/debounce';
import Button from '@material-ui/core/Button';
import $ from 'jquery';

class Ads extends React.Component {
    state = {
        data: {
            campaign_id : "",
            client_id: "",
            client_name: "",
            campaign_companies: null,
            linkedin_company_id: "",
            introText_a: "",
            destinationUrl_a: "",
            headline_a: "",
            introText_b: "",
            destinationUrl_b: "",
            headline_b: "",
            publish_ad_status: 'DRAFT',
            call_to_action: 'SIGN_UP',
            form_version: null,
            form_element: null,
            image_json_a: "",
            image_json_b: "",
            companies: [],
            cursor_position: null,
            image_a_url: '',
            image_b_url: ''
        },
        generating_images: false,
        version: 1,
        lead_gen_actions: []
    };

    componentDidMount() {
        if (this.props.data) {
            if (this.props.data.campaignId) {
                const url = "/api/campaigns/fetch?campaign_id=" + this.props.data.campaignId;
                ApiService.get(url)
                    .then(response => {
                        let campaign = response.data.Campaign;
                        if (campaign) {
                            this.setState({
                                data: campaign,
                            }, () => {

                                this.fetchCampaignCompanies();

                                if (this.state.data.objective_type === "LEAD_GENERATION") {
                                    document.getElementById('call-to-action').style.display = 'block';
                                    document.getElementById('lead-gen').style.display = 'block';
                                    this.fetchLeadGenForms();
                                    this.fetchLeadGenActions();
                            
                                } else if (this.state.data.objective_type === "WEBSITE_VISIT") {
                                    document.getElementById('call-to-action').style.display = 'block';
                                    document.getElementById('lead-gen').style.display = 'none';
                                    this.fetchLeadGenActions();
                                } else {
                                    document.getElementById('call-to-action').style.display = 'none';
                                    document.getElementById('lead-gen').style.display = 'none';
                                }

                            });
                        }
                    })
                    .catch(error => {
                        console.log(error);
                    })
            }

        }

    }

    fetchLeadGenForms()
    {
        var leadGenFormList = document.getElementById('lead_gen_form');

        ApiService.post('/api/linkedin/lead-gen-forms', {'client_id': this.state.data.client_id})
            .then(response => {
                if (response.data.success) {
                    for (const [key, value] of Object.entries(response.data.forms)) {
                        var item = document.createElement('option');
                        item.value = key;
                        item.text = value;
                        leadGenFormList.options.add(item);
                    }

                    leadGenFormList.value = this.state.data.lead_gen_form;
                } else {
                    AlertService.error('Error: ' + response.data.error);
                }

            })
    }

    /**
     * Retrieve all available lead gen action options from the database
     */
    fetchLeadGenActions = () => {
        ApiService.get('/api/linkedin/lead-gen-actions')
        .then(response => {

            let actionsArray = [];
            const actions = response.data;

            actions.forEach(action => {
                const label = this.transformStringForLabel(action.Name);
                actionsArray.push({key: action.ID, value: label});
            });

            this.setState({...this.state, lead_gen_actions: actionsArray});
            
        })
    }

    /**
     * Transforms a string into a user friendly label. 
     * e.g 'GET_OPTIONS' becomes 'Get Options'
     * 
     */
    transformStringForLabel = (str) => {
        // Replace underscores with spaces
        let result = str.replace(/_/g, ' ');

        // Convert to lowercase and capitalize the first letter of each word
        result = result.toLowerCase().replace(/\b\w/g, function(match) {
            return match.toUpperCase();
        });

        return result;
    }


    insertCompanyName() {
        let property = this.state.data.form_element + "_" + this.state.data.form_version;
        let cursorPosition = this.state.data.cursor_position;
        let textBeforeCursor = "";
        let textAfterCursor = "";

        switch(property){
            case "introText_a":
                textBeforeCursor = this.state.data.introText_a.substring(0, cursorPosition);
                textAfterCursor = this.state.data.introText_a.substring(cursorPosition, this.state.data.introText_a.length);
                break;
            case "introText_b":
                textBeforeCursor = this.state.data.introText_b.substring(0, cursorPosition);
                textAfterCursor = this.state.data.introText_b.substring(cursorPosition, this.state.data.introText_b.length);
                break;
            case "destinationUrl_a":
                textBeforeCursor = this.state.data.destinationUrl_a.substring(0, cursorPosition);
                textAfterCursor = this.state.data.destinationUrl_a.substring(cursorPosition, this.state.data.destinationUrl_a.length);
                break;
            case "destinationUrl_b":
                textBeforeCursor = this.state.data.destinationUrl_b.substring(0, cursorPosition);
                textAfterCursor = this.state.data.destinationUrl_b.substring(cursorPosition, this.state.data.destinationUrl_b.length);
                break;
            case "headline_a":
                textBeforeCursor = this.state.data.headline_a.substring(0, cursorPosition);
                textAfterCursor = this.state.data.headline_a.substring(cursorPosition, this.state.data.headline_a.length);
                break;
            default:
                textBeforeCursor = this.state.data.headline_b.substring(0, cursorPosition);
                textAfterCursor = this.state.data.headline_b.substring(cursorPosition, this.state.data.headline_b.length);
                break;
        }
        let message = textBeforeCursor + "{COMPANY_NAME}" + textAfterCursor;

        this.setState({...this.state, data:{...this.state.data, [property]: message}});
    }

    onChildChange(version, formElement, formValue, cursorPosition) {
        let property = formElement + "_" + version;
        let value = formValue.toString();

        this.setState({...this.state, data:{...this.state.data, [property]: value, form_version: version, form_element: formElement, cursor_position: cursorPosition}});
    }

    handleSelectChange(e) {
        this.setState({...this.state, data:{...this.state.data, [e.target.name]: e.target.value}});
    }

    // The imageEditor waits 1500ms to save its state, so this also needs to wait 1500ms before saving to ensure that the imageEditor state has been saved
    saveAdForm = _debounce(() => {
        delete this.state.data['categories'];

        this.setState({...this.state, data:
                {...this.state.data,
                    introText_a: this.state.data.introText_a.trim(),
                    introText_b: this.state.data.introText_b.trim(),
                    destinationUrl_a: this.state.data.destinationUrl_a.trim(),
                    destinationUrl_b: this.state.data.destinationUrl_b.trim(),
                    headline_a: this.state.data.headline_a.trim(),
                    headline_b: this.state.data.headline_b.trim()}});


        let stateCopy = JSON.parse(JSON.stringify(this.state));
        stateCopy.data.image_json_a = this.isJSON(this.state.data.image_json_a) ? JSON.stringify(this.state.data.image_json_a) : this.state.data.image_json_a;
        stateCopy.data.image_json_b = this.isJSON(this.state.data.image_json_b) ? JSON.stringify(this.state.data.image_json_b) : this.state.data.image_json_b;

        ApiService.post("/api/campaigns/update", stateCopy.data)
            .then(response => {
                if (response.data.Success) {
                    AlertService.success('Campaign saved successfully');
                } else {
                    AlertService.error('Oops! There was an error saving the Campaign');
                }
            })
            .catch(error => {
                AlertService.error('Oops! There was an error saving the Campaign');
            });
    }, 1500);


    // need to debounce setting the state so that the changes appear smooth in the image editor
    handleEditorAChange = _debounce((json) => {

        this.setState({...this.state, data:{...this.state.data, image_json_a: json}});

    }, 1500);

    // need to debounce setting the state so that the changes appear smooth in the image editor
    handleEditorBChange = _debounce((json) => {

        this.setState({...this.state, data:{...this.state.data, image_json_b: json}});

    }, 1500);


    /**
     *  Calls the backend to generate new images for all the accounts in this campaign using the JSON data
     *  from the image editor.
     */
    generateImages = () => {

        delete this.state.data['categories'];

        this.setState({...this.state, data:{...this.state.data}, generating_images: true});

        let stateCopy = JSON.parse(JSON.stringify(this.state));
        stateCopy.data.image_json_a = this.isJSON(this.state.data.image_json_a) ? JSON.stringify(this.state.data.image_json_a) : this.state.data.image_json_a;
        stateCopy.data.image_json_b = this.isJSON(this.state.data.image_json_b) ? JSON.stringify(this.state.data.image_json_b) : this.state.data.image_json_b;

        ApiService.post("/api/campaigns/update", stateCopy.data)
            .then(response => {
                if (response.data.Success) {
                    ApiService.post("/api/polotno/generate-images", {'campaign_id': this.state.data.campaign_id})
                        .then(response => {

                            if (response.data.Success) {
                                AlertService.success('Successfully generated images for all accounts.');
                            } else {
                                let message = response.data.Error;

                                let imageInfoEl = document.getElementById('image-info');
                                imageInfoEl.innerText = message;
                                imageInfoEl.style.display = 'block';

                            }

                            this.setState({...this.state, data:{...this.state.data}, generating_images: false});

                        })
                } else {
                    AlertService.error('Oops! There was an error saving the Campaign');
                }

            })
            .catch(error => {
                AlertService.error('Oops! There was an error saving the Campaign');
            });

    };

    fetchCampaignCompanies = () => {
        let campaign_id = this.state.data.campaign_id;
        ApiService.get('/api/campaigns/linkedin-companies?campaign_id=' + campaign_id).then(response => {

            let companies = response.data.Companies;
            var companyNames = companies.map(company => company.common_name);

           this.setState({...this.state, data: {...this.state.data, companies: companyNames}})

        });
    };

    handleImageAUpload = (e) => {
        let file = e.target.files[0];
        
        ApiService.post('/api/campaigns/upload-image', {'campaign_id': this.state.data.campaign_id, 'image': file, 'ad_number': 1})
        .then(response => {
            if (response.data.Success) {
                this.setState({...this.state, data: {...this.state.data, image_a_url: response.data.URL}})
            } else {
                AlertService.error('Failed to upload image');
            }
        })
    }

    handleImageBUpload = (e) => {
        let file = e.target.files[0];
        
        ApiService.post('/api/campaigns/upload-image', {'campaign_id': this.state.data.campaign_id, 'image': file, 'ad_number': 2})
        .then(response => {
            if (response.data.Success) {
                this.setState({...this.state, data: {...this.state.data, image_b_url: response.data.URL}}, () => console.log(this.state.data))
            } else {
                AlertService.error('Failed to upload image');
            }
        })
    }

    setVersion = (e) => {
        let version = e.target.name === 'version_a' ? 1 : 2;
            this.setState({...this.state, version: version});
    }

    isJSON(data) {
        var isJson = false;
        try {
            JSON.parse(data);
        }catch(e) {
            isJson = true;
        }
        return isJson;
    }

     render() {
         return(
             <div className="page-main">
                 <div className="form-container">

                     <div className="form-ads">
                         <div id="image-info" className="alert alert-danger"> </div>

                         <div>
                             <button style={{maxWidth: 'none'}} className="outline" onClick={this.insertCompanyName.bind(this)}>Insert Company Name</button>
                             <button className="outline" onClick={this.generateImages} disabled={this.state.generating_images || !this.state.data.image_json_a}>Generate Images</button>
                             <div className="right">
                                <button name='version_a' className={this.state.version === 1 ? '' : 'outline inactive'} onClick={this.setVersion}>A</button>
                                <button name='version_b' className={this.state.version === 1 ? 'outline inactive' : ''} onClick={this.setVersion}>B</button>
                          </div>
                         </div>
                         <div>
                             <h4 style={{marginBottom: 0}}>Publish Ad Status</h4>
                             <select name="publish_ad_status" id="publishAdStatus" value={this.state.data.publish_ad_status} onChange={(e) => this.handleSelectChange(e)}>
                                 <option value="ACTIVE">ACTIVE</option>
                                 <option value="DRAFT">DRAFT</option>
                             </select>
                         </div>
                         <div style={{display: this.state.version === 1 ? 'block' : 'none' }}>
                             <h4>Version A</h4>
                             <div className="ad-box">
                                 <AdForm version={"a"} data={this.state.data} onFormChange={this.onChildChange.bind(this)}/>
                             </div>

                             <div>
                             <div className="section upload-file-section">
                                 <input
                                     type="file"
                                     accept="image/*"
                                     style={{ display: 'none' }}
                                     id="image-a-upload-button"
                                     onChange={this.handleImageAUpload}
                                 />
                                 <label htmlFor="image-a-upload-button">
                                     <Button variant="contained" color="primary" component="span">
                                         Upload Image
                                     </Button>
                                 </label>
                             </div>
                             
                             <DesignEditor
                                 API_KEY={process.env.REACT_APP_POLOTNO_API_KEY}
                                 companies={this.state.data.companies}
                                 style={{ height: '100vh' }}
                                 onChange={this.handleEditorAChange}
                                 json={this.state.data.image_json_a}
                                 backgroundImage={this.state.data.image_a_url ? this.state.data.image_a_url : undefined}
                             />
                         </div>
                         </div>

                         <div style={{display: this.state.version === 2 ? 'block' : 'none' }}>
                             <h4>Version B</h4>
                             <div className="ad-box">
                                 <AdForm version={"b"} data={this.state.data} onFormChange={this.onChildChange.bind(this)}/>
                             </div>

                             <div>
                             <div className="section upload-file-section">
                                 <input
                                     type="file"
                                     accept="image/*"
                                     style={{ display: 'none' }}
                                     id="image-b-upload-button"
                                     onChange={this.handleImageBUpload}
                                 />
                                 <label htmlFor="image-b-upload-button">
                                     <Button variant="contained" color="primary" component="span">
                                         Upload Image
                                     </Button>
                                 </label>
                             </div>
                             
                             <DesignEditor
                                 API_KEY={process.env.REACT_APP_POLOTNO_API_KEY}
                                 companies={this.state.data.companies}
                                 style={{ height: '100vh' }}
                                 onChange={this.handleEditorBChange}
                                 json={this.state.data.image_json_b}
                                 backgroundImage={this.state.data.image_b_url ? this.state.data.image_b_url : undefined}
                             />
                         </div>
                         </div>

                         <div id="call-to-action">
                             <div className="divider"></div>

                             <h3> Form Details </h3>
                             <h4> Call-to-action </h4>
                             <select name="call_to_action" value={this.state.data.call_to_action} onChange={(e) => this.handleSelectChange(e)}>
                                 <option value={0}>(Select one)</option>
                                 {this.state.lead_gen_actions.map(option => (
                                     <option key={option.key} value={option.key}>
                                         {option.value}
                                     </option>
                                 ))}
                             </select>
                         </div>
                         <div id="lead-gen">
                             <h4> Form</h4>
                             <select id="lead_gen_form" name="lead_gen_form" onChange={(e) => this.handleSelectChange(e)}> <option value="">Select one</option></select>
                         </div>

                     </div>
                     <hr width="1"></hr>
                     <div className="form-submit">
                         <button onClick={this.saveAdForm.bind(this)}>Save</button>
                         <button type="button" className="outline"
                                 onClick = {() => {this.props.history.push("/campaigns?client_id="+ this.state.data.client_id + "&client_name=" + this.state.data.client_name)}}>
                             Cancel
                         </button>
                     </div>
                 </div>
             </div>
         )
     }
}

export default Ads